import React from 'react';
import { renderToString } from 'react-dom/server';
import { ReactComponent as besmart } from "../../assets/BesmartBot.svg";
import { Box } from '@mui/material';

const getSVGDataURL = (SvgComponent: React.FunctionComponent<React.SVGProps<SVGSVGElement>>) => {
	const svgString = renderToString(<SvgComponent />);
	return `data:image/svg+xml;base64,${window.btoa(svgString)}`;
};

const BesmartLogo = () => {
	const backgroundImageUrl = getSVGDataURL(besmart);

	return (
		<Box>
        <Box
          sx={{
            width: 193,
            height: 193,
            backgroundImage: `url(${backgroundImageUrl})`,
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
          }}
        />
      </Box>
	);
};

export default BesmartLogo;